module.exports = __webpack_public_path__ + "img/b.e6a20943.jpg";